import type { BaseMetadata, ThreadData } from "@liveblocks/client"
import { FloatingThreads } from "@liveblocks/react-tiptap"
import { Thread } from "@liveblocks/react-ui"
import type { Editor } from "@tiptap/core"

export function CustomThreads({
  editor,
  threads,
}: {
  editor: Editor
  threads: ThreadData<BaseMetadata>[] | undefined
}) {
  return (
    <FloatingThreads
      editor={editor}
      threads={threads ?? []}
      components={{
        Thread: ({ thread }) => (
          <Thread thread={thread} showReactions={false} showComposer={false} />
        ),
      }}
    />
  )
}
